var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1209.78 1428.88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 784.18,
    cy: 828.15,
    fill: "#f4f5f7",
    r: 100.84
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-155.82 -536.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m943.51 1243.68a116.51 116.51 0 0 1 116.49 116.49v3.5h-3.5a116.51 116.51 0 0 1 -116.5-116.49v-3.5z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823.53 1363.7h-3.53v-3.49a116.5 116.5 0 0 1 116.48-116.52h3.52v3.5a116.5 116.5 0 0 1 -116.47 116.51z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1236 848.15h3.5v3.49a116.51 116.51 0 0 1 -116.5 116.53h-3.49v-3.5a116.5 116.5 0 0 1 116.49-116.52z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1362.1 969.05a116.51 116.51 0 0 1 -116.52-116.49v-3.49h3.49a116.5 116.5 0 0 1 116.53 116.48v3.5z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.75 1029.06h120v120a120 120 0 0 1 -120 120h-120v-120a120 120 0 0 1 120-120z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.35 1029.06h48v48a72 72 0 0 1 -72 72h-48v-48a72 72 0 0 1 72-72z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.87 1029.06a120 120 0 1 0 0 240h120v-120a120 120 0 0 0 -120-120z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.11 1125.54a71.76 71.76 0 1 0 0 143.52h71.76v-71.76a71.76 71.76 0 0 0 -71.76-71.76z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.87 1074.58a73.27 73.27 0 1 0 73.26 73.27 73.27 73.27 0 0 0 -73.26-73.27z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.87 1105a42.89 42.89 0 1 0 42.89 42.89 42.89 42.89 0 0 0 -42.89-42.89z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m881.34 898.26v107.47h-107.47a108.55 108.55 0 0 1 -108.55-108.55v-107.47h107.47a108.55 108.55 0 0 1 108.55 108.55z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m826 910.45a70.55 70.55 0 1 1 -141.1 0v-70.55h70.55a70.55 70.55 0 0 1 70.55 70.55z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.33 1271.47a120 120 0 1 0 0-240h-120v120a120 120 0 0 0 120 120z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m756.09 1175a71.76 71.76 0 0 0 0-143.52h-71.76v71.76a71.76 71.76 0 0 0 71.76 71.76z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.33 1225.94a73.27 73.27 0 1 0 -73.27-73.27 73.27 73.27 0 0 0 73.27 73.27z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.33 1195.56a42.89 42.89 0 1 0 -42.89-42.89 42.89 42.89 0 0 0 42.89 42.89z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.64 945.47a59 59 0 1 0 59-59 59 59 0 0 0 -59 59z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.61 1400a33.21 33.21 0 1 0 33.21-33.21 33.21 33.21 0 0 0 -33.21 33.21z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 1400a59 59 0 1 0 59-59 59 59 0 0 0 -59 59z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.33 1657 49.81-33.72a60.44 60.44 0 1 0 -83.69-16.28z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.23 1542.06a33.21 33.21 0 1 0 33.21-33.21 33.21 33.21 0 0 0 -33.21 33.21z",
    fill: "#fb6340"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 388.68,
    cy: 432.07,
    fill: "#172b4d",
    r: 70.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 845.28,
    cy: 374.35,
    fill: "#fb6340",
    r: 103.89
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.44,
    cy: 372.36,
    fill: "#f4f5f7",
    r: 37.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "m781.49 1226.59c0 66-53.33 119.41-119.12 119.41 0-65.95 53.33-119.41 119.12-119.41z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.86 1345.56 1.63 3.08-3.06 1.62c-56.45 29.88-126.5 8.24-156.45-48.35l-1.63-3.07 3.06-1.62c56.45-29.89 126.5-8.22 156.45 48.34z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m614.37 1441.44 1.5-3.13 3.14 1.5c57.74 27.68 82.16 96.8 54.55 154.4l-1.5 3.13-3.13-1.51c-57.74-27.67-82.16-96.83-54.56-154.39z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m781.49 1463.11v3.48h-3.49c-63.87 0-115.65-51.9-115.65-115.93v-3.48h3.47c63.89 0 115.67 51.91 115.67 115.93z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866.31 964.69h121.2l-60.6 60.6z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1046.91 964.69v240h-240z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m806.91 964.69 240 240h-240z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-155.82 -536.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m881.54 671.83a120 120 0 1 1 -240 .4l-.2-120 120-.2a120 120 0 0 1 120.2 119.8z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785 623.75a71.76 71.76 0 0 1 -143.52.24l-.12-71.76 71.76-.12a71.76 71.76 0 0 1 71.88 71.64z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m836 671.9a73.27 73.27 0 1 1 -73.39-73.14 73.26 73.26 0 0 1 73.39 73.14z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1119.48 1406.58v-119.39h119.39a120.6 120.6 0 0 1 120.61 120.6v119.4h-119.4a120.6 120.6 0 0 1 -120.6-120.61z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1171.34 1407.19a70.55 70.55 0 1 1 141.1 0v70.55h-70.55a70.55 70.55 0 0 1 -70.55-70.55z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1119.48 1334.58v-48h48a72 72 0 0 1 72 72v48h-48a72 72 0 0 1 -72-72z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1235 555.49h120v120a120 120 0 0 1 -120 120h-120v-120a120 120 0 0 1 120-120z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1235 607.35a70.55 70.55 0 1 1 0 141.1h-70.55v-70.55a70.55 70.55 0 0 1 70.55-70.55z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1307.64 555.49h48v48a72 72 0 0 1 -72 72h-48v-48a72 72 0 0 1 72-72z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1008 546.64a120 120 0 0 1 0 240h-120v-120a120 120 0 0 1 120-120z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.72 643.13a71.76 71.76 0 1 1 0 143.51h-71.72v-71.75a71.76 71.76 0 0 1 71.72-71.76z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1008 592.17a73.27 73.27 0 1 1 -73.27 73.27 73.27 73.27 0 0 1 73.27-73.27z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1008 622.55a42.89 42.89 0 1 1 -42.89 42.89 42.89 42.89 0 0 1 42.89-42.89z",
    fill: "#172b4d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m963.66 1393.04-85.13-85.19 85.13-85.19 85.12 85.19z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m993.97 1338.18h-60.62v-60.67h60.62z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.35 814.43a59 59 0 1 1 59-59 59 59 0 0 1 -59 59z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.49 926.71a40.21 40.21 0 1 1 40.21-40.2 40.2 40.2 0 0 1 -40.21 40.2z",
    fill: "#fb6340",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m628.55 667.79h-60.44a60.45 60.45 0 1 1 60.44-60.44z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1144.41 1132.32a59 59 0 1 1 59-59 59 59 0 0 1 -59 59z",
    fill: "#fb6340",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001.1 1183.28a59 59 0 1 1 59-59 59 59 0 0 1 -59 59z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1285.56 1098.77a59 59 0 1 1 59-59 59 59 0 0 1 -59 59z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1272.69 1270.24h-60.44a60.45 60.45 0 1 1 60.44-60.44z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.82 536.1a120 120 0 1 1 -120 120 120 120 0 0 1 120-120z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.41 584.45a72.24 72.24 0 1 1 -72.24 72.24 72.24 72.24 0 0 1 72.24-72.24z",
    fill: "#f4f5f7",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.59 619.25a38.62 38.62 0 1 1 -38.59 38.62 38.62 38.62 0 0 1 38.59-38.62z",
    fill: "#172b4d",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1326.65 1698.76h3.49v3.49a116.5 116.5 0 0 1 -116.5 116.51h-3.5v-3.5a116.5 116.5 0 0 1 116.51-116.5z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1215.17 1550.34a116.5 116.5 0 0 1 116.5 116.5v3.5h-3.49a116.51 116.51 0 0 1 -116.51-116.51v-3.49z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 662.36,
    cy: 1062.33,
    fill: "#f4f5f7",
    rx: 100.84,
    ry: 100.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "m937.89 1478.73c0 66-53.33 119.41-119.12 119.41 0-65.95 53.33-119.41 119.12-119.41z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m817 1594.66v3.48h-3.47c-63.87 0-115.65-51.9-115.65-115.93v-3.48h3.47c63.88 0 115.65 51.9 115.65 115.93z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m813.54 1599.32h3.46v3.48c0 64-51.78 115.93-115.65 115.93h-3.47v-3.48c.01-64.02 51.79-115.93 115.66-115.93z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m937.89 1715.25v3.48h-3.47c-63.87 0-115.65-51.9-115.65-115.93v-3.48h3.47c63.87 0 115.65 51.91 115.65 115.93z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.23 1795v96.15h96.15a97.12 97.12 0 0 0 97.12-97.15v-96.15h-96.15a97.12 97.12 0 0 0 -97.12 97.15z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558 1794.47a70.55 70.55 0 1 0 141.1 0v-70.55h-70.55a70.55 70.55 0 0 0 -70.55 70.55z",
    fill: "#172b4d",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.9 1819.22a120 120 0 0 0 0-240h-120v120a120 120 0 0 0 120 120z",
    fill: "#f4f5f7",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.66 1722.74a71.76 71.76 0 0 0 0-143.52h-71.76v71.78a71.76 71.76 0 0 0 71.76 71.74z",
    fill: "#172b4d",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.9 1773.7a73.27 73.27 0 1 0 -73.26-73.27 73.27 73.27 0 0 0 73.26 73.27z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.9 1743.32a42.89 42.89 0 1 0 -42.9-42.89 42.89 42.89 0 0 0 42.9 42.89z",
    fill: "#172b4d",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788.25 1906a59 59 0 1 0 59-59 59 59 0 0 0 -59 59z",
    fill: "#f5365c",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m860.05 1782.89a59 59 0 1 0 59-59 59 59 0 0 0 -59 59z",
    fill: "#fb6340",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m712.89 1722.74v60.15a60.44 60.44 0 1 0 60.44-60.15z",
    fill: "#2dce89",
    transform: "translate(-155.82 -536.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 911.05,
    fill: "#fb6340",
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.6,
    cy: 911.65,
    fill: "#172b4d",
    r: 70.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.6,
    cy: 911.65,
    fill: "#f4f5f7",
    r: 37.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP8);
export default __webpack_public_path__ + "static/media/p8.e75b4989873fa389aa20469e382296dc.svg";
export { ForwardRef as ReactComponent };